import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { formatDisplayAmount } from '@frontend/currency';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

const styles = {
  invoiceCard: css`
    display: flex;
    flex-flow: row;
    align-content: center;
    justify-content: space-between;
    border: 1px solid ${theme.colors.primary50};
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spacing(2)};
    margin-top: ${theme.spacing(2)};
    height: ${theme.spacing(10)};
  `,
  requestedAmount: css`
    display: flex;
    flex-flow: column;
  `,
  noMargin: css`
    margin: 0;
  `,
};

interface RequestedAmountProps {
  amount: number;
  action?: ReactNode;
}

export const RequestedAmount = ({ amount, action }: RequestedAmountProps) => {
  const { t } = useTranslation('weavepay');

  return (
    <div css={styles.invoiceCard}>
      <div css={styles.requestedAmount}>
        <Text color='light' size='medium' css={styles.noMargin}>
          {t('Requested Amount')}
        </Text>
        <Text size='large' css={styles.noMargin}>
          {formatDisplayAmount(amount)}
        </Text>
      </div>
      {action}
    </div>
  );
};
